import { Heading } from '../common/heading';
import { binarySearch } from '../js-playground/algorithms/binary-search/explain-2';
import {
	average,
	DATES,
	FilterAndSumValues,
	joinStrings,
	maxDate,
	moreThanTwo,
	multiplyThree,
	ReducedPersons,
	sum,
	SUMARR,
	SumArrObj,
	sumReducer,
	uniqueAgeGroup,
} from '../js-playground/arrays/map-filter-reduce';
import {
	DeFuncPerson,
	Dename,
	DeRest,
	Dx,
	h,
	s,
	t,
	w,
} from '../js-playground/destructuring/explain';
import { displaySquare } from '../js-playground/functions/explain';
import {
	countToTen,
	fibonacciWithoutRecurring,
	fibonacciWithRecurring,
	RecursiveFactorial,
	recurToTen,
} from '../js-playground/functions/recursives';
import { promise } from '../js-playground/promises/promises';

const JsArrays = () => {
	// ------------------------- Array Basic ----------------------------

	const arr: any[] = [1, 2, 3];
	arr[2] = 9;
	arr[3] = {
		name: 'thuta',
	};
	const lol = arr[arr.length - 1];
	const lol2 = arr.at(-2);

	let arr1 = [1, 2, 3, 4, 5, 6, 7, 8];
	delete arr1[2];
	console.log('arr1', arr1);

	console.log('multiplyThree', multiplyThree);
	console.log('moreThanTwo', moreThanTwo);
	console.log('sum', sum);

	// ------------------------- Reduce ----------------------------
	const messages = ['javascript', 'is', 'good'];
	const joinedStrings = messages.reduce(joinStrings);
	console.log('joinedStrings', joinedStrings);
	const numbers = [1, 2, 3, 4, 5, 6];
	const sumNumbers = numbers.reduce(sumReducer);
	console.log('sumNumbers', sumNumbers);
	console.log('uniqueAgeGroup', uniqueAgeGroup);
	console.log('ReducedPersons', ReducedPersons);
	console.log('average', average);
	console.log('SumArrObj', SumArrObj);
	console.log('FilterAndSumValues', FilterAndSumValues);
	const ARRAY = [1, 2, 3, 4, 5];
	console.log('SUMARR(ARRAY)', SUMARR(ARRAY));
	console.log('maxDate', new Date(maxDate).toDateString());

	// ------------------------- Slice ----------------------------
	const SliceNumbers: number[] = [1, 2, 3, 4, 5];
	const SlicedNumbers = SliceNumbers.slice(-3);
	console.log('SlicedNumbers', SlicedNumbers);

	const SliceNames = ['hsu', 'thuta', 'yeywel', 'babe', 'khlayy'];
	const SlicedNames = SliceNames.slice(0, 3);
	console.log('SlicedNames', SlicedNames);

	// ------------------------- DeStructure ----------------------------
	console.log('x', Dx);
	console.log('t', t);
	console.log('s', s);
	console.log('h', h);
	console.log('w', w);

	console.log('DName', Dename);
	console.log('DRest', DeRest);

	console.log('DeFuncPerson', DeFuncPerson);

	// ------------------------- Functions ----------------------------
	function square(num: number) {
		return num * num;
	}

	displaySquare(square);

	// IIFE
	console.log('IIFE ===>');
	(function square(num: number): number {
		console.log(num * num);
		return num * num;
	})(5);

	// IIFE - O/P Based
	(function (x) {
		return (function (y) {
			console.log(x, y);
		})(2);
	})(4);

	function ArrSpeardMultiply(num1, num2) {
		console.log(num1 * num2);
	}
	var ARRRMultiply = [5, 6];
	ArrSpeardMultiply('...ARRRMultiply', ARRRMultiply);

	// ------------------------- Promises ----------------------------
	console.log(promise);
	// ------------------------- Recursive ----------------------------
	console.log('recurToTen()', recurToTen());
	console.log('fibonacciWithoutRecurring(12)', fibonacciWithoutRecurring(12));
	console.log('fibonacciWithRecurring()', fibonacciWithRecurring(12));
	console.log('RecursiveFactorial', RecursiveFactorial(4));

	// ------------------------- Binary Search ----------------------------
	const BiNumbers: number[] = [1, 5, 7, 64, 777, 1000, 1002, 1003];
	console.log('Found number at: ' + binarySearch(64, BiNumbers));

	return (
		<div>
			<Heading
				text="Javascsripts"
				description="In this section, Javascript Concepts will be Demonstrated."
			/>
		</div>
	);
};

export default JsArrays;
